export default "__VITE_ASSET__C50fe0Mv__"